import { parse } from "date-fns";

// Categorical series colors, in fixed order. Validated for color-vision
// deficiency on the white card surface (adjacent ΔE ≥ 9). Aqua, yellow and
// magenta are below 3:1 contrast on white, so every chart using them keeps a
// legend and tooltips. Never extend this list: fold extra series into
// "Other" instead.
export const SERIES_COLORS = [
  "#2a78d6", // blue
  "#eb6834", // orange
  "#1baf7a", // aqua
  "#eda100", // yellow
  "#e87ba4", // magenta
  "#008300", // green
  "#4a3aa7", // violet
  "#e34948", // red
];

export const OTHER_COLOR = "#c4cdd5";

export const MAX_SERIES = SERIES_COLORS.length;

export const seriesColor = (index) => SERIES_COLORS[index] ?? OTHER_COLOR;

// Status colors: only for up/down style states, always shown with a label
export const STATUS_COLORS = {
  good: "#0ca30c",
  warning: "#fab219",
  critical: "#d03b3b",
  empty: "#dfe3e8",
};

export const CHART_TEXT = {
  primary: "#212b36",
  secondary: "#637381",
  muted: "#919eab",
};

const FONT_FAMILY = '"Public Sans", sans-serif';

export const nivoTheme = {
  text: { fontFamily: FONT_FAMILY, fontSize: 11, fill: CHART_TEXT.secondary },
  axis: {
    domain: { line: { stroke: "#dfe3e8", strokeWidth: 1 } },
    ticks: {
      line: { stroke: "#dfe3e8", strokeWidth: 1 },
      text: { fontFamily: FONT_FAMILY, fontSize: 11, fill: CHART_TEXT.secondary },
    },
  },
  grid: { line: { stroke: "#eef0f2", strokeWidth: 1 } },
  crosshair: {
    line: { stroke: CHART_TEXT.muted, strokeWidth: 1, strokeOpacity: 0.6 },
  },
};

const compactUsd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  notation: "compact",
  maximumFractionDigits: 1,
});

const fullUsd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const formatCompactUsd = (value) =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? "–"
    : compactUsd.format(Number(value));

export const formatUsd = (value) =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? "–"
    : fullUsd.format(Number(value));

export const formatPercent = (value) =>
  `${value >= 10 ? value.toFixed(0) : value.toFixed(1)}%`;

// Chart data carries dates as "dd-MM-yyyy HH:mm" strings
export const parseChartDate = (value) =>
  value instanceof Date ? value : parse(value, "dd-MM-yyyy HH:mm", new Date());
